// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","documents":"aSXSt_Gp3yIU_nqNLeSs4","documentInput":"_222gAuALh143OrO0W-hJSg"};